<template>
	<div class="integral-goods-details-container">
		<div class="backBox" @click="handleClose">
			<img class="backIcon" src="../assets/Personal/iconI.png" />
			返回
		</div>
		<div class="userInfoItem" v-if="goods.cat_type == 1">
			<div class="itemTitle">
				收货信息
				<div class="addressMenu">
					<div class="addAddress" @click="curAddress = {};dialogReplyViable = true">使用新地址</div>
				</div>
			</div>
			<div class="itemContent">
				<button class="prev-btn" @click="prevImage" v-if="address.length > 3">
					<img src="../assets/MyOrder/iconH.png">
				</button>
				<div class="addressList" ref="thumbnailContainer">
					<div class="addressItem" :class="selAddressIndex == index ? 'active' : 'normal'"
						v-for="(item,index) in address" :key="index" @click="selAddressIndex = index">
						<div class="province ellipsis-1">{{item.sheng}} {{item.shi}} {{item.qu}}</div>
						<div class="address ellipsis-1">{{item.address}}</div>
						<div class="namePhone ellipsis-1">{{item.name}} {{item.phone}}</div>
						<div class="editMenu">
							<img class="editIcon" src="../assets/Personal/iconC.png"
								@click.stop="curAddress = item;dialogReplyViable = true" />
							<img class="editIcon" src="../assets/Personal/iconB.png" @click.stop="delAddress(item)" />
						</div>
					</div>
				</div>
				<button class="next-btn" @click="nextImage" v-if="address.length > 3">
					<img src="../assets/MyOrder/iconI.png">
				</button>
			</div>
		</div>
		<div class="userInfoItem">
			<div class="itemTitle">
				确认订单信息
			</div>
			<div class="itemContent">
				<div class="integral-goods-details">
					<div class="image-gallery">
						<div class="main-image" v-if="goods.cat_type == 1">
							<img :src="goods.img" />
						</div>
						<div class="main-imageT" v-if="goods.cat_type == 2">
							<img :src="goods.img" />
						</div>
					</div>
					<div class="integral-goods">
						<div class="title">{{goods.title ? goods.title : ''}}</div>
						<div class="price">{{goods.price ? goods.price : '0'}}积分</div>
						<div class="specs" v-if="goods.cat_type == 2">
							<span class="infoTitle">类型：</span>{{goods.type ? (goods.type  == 1 ? '满减券' : '折扣券') : ''}}
						</div>
						<div class="specs" v-if="goods.cat_type == 2 && goods.type  == 1">
							<span class="infoTitle">
								使用限制：
							</span>满{{goods.max_price ? goods.max_price : '0'}}减{{goods.original_price ? goods.original_price : '0'}}
						</div>
						<div class="specs" v-if="goods.cat_type == 2 && goods.type  == 2">
							<span class="infoTitle">
								使用限制：
							</span>满{{goods.max_price ? goods.max_price : '0'}}可用
						</div>
						<div class="specs" v-if="goods.cat_type == 2">
							<span class="infoTitle">
								有效期：
							</span>{{goods.day ? goods.day : '0'}}天
						</div>
						<div class="specs" v-if="goods.cat_type == 2">
							<span class="infoTitle">
								金额：
							</span>{{goods.original_price ? goods.original_price : '0'}}元
						</div>
						<div class="specs" v-if="goods.cat_type == 1">
							<span class="infoTitle">
								规格：
							</span>
							{{goods.specs ? goods.specs : ''}}
						</div>
						<div class="inventory"><span class="infoTitle">库存：</span>{{goods.stock ? goods.stock : '0'}}
						</div>
						<div class="buyCount"><span
								class="infoTitle">兑换量：</span>{{goods.buy_count ? goods.buy_count : '0'}}
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="exchangNum">
			兑换数量
			<div class="numBox">
				<img src="../assets/Personal/iconM.png" @click="reduceNum" />
				<div class="num">{{count}}</div>
				<img src="../assets/Personal/iconN.png" @click="addNum" />
			</div>
		</div>
		<div class="agreementBox">
			<img class="checkIcon" src="../assets/BuyNow/iconA.png" @click="agree = false" v-if="agree" />
			<img class="checkIcon" src="../assets/BuyNow/iconH.png" @click="agree = true" v-else />
			我已阅读并同意 <span class="userAgreement" @click="userBuy = true">《用户购买须知协议》</span>
		</div>
		<div class="exchange" @click="exchangeGoods">立即兑换</div>
		<AddAddress :show="dialogReplyViable" :data="curAddress" @close="dialogReplyViable = false"
			@update="userAddress" />
		<UserBuyAgreeDialog :show="userBuy" @close="userBuy = false" />
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'兑换成功！'"
			@clickOk="sucPop = false;$emit('exchangeSuc',goods)" v-if="sucPop" />
		<PopToast :imgPtahUrl="require('@/assets/Register/exclaim.png')"
			:desc="errorDesc == '积分不足' ? '您当前积分不足,快去获取积分吧' : errorDesc" @clickOk="errorChange" v-if="tipPop" />
	</div>
</template>

<script>
	import PopToast from '../components/PopToast.vue'
	import AddAddress from '../../src/components/AddAddress.vue'
	import UserBuyAgreeDialog from '../components/UserBuyAgreeDialog.vue'

	export default {
		components: {
			PopToast,
			AddAddress,
			UserBuyAgreeDialog
		},
		props: {
			goods: {
				type: Object,
				default: () => {}
			}
		},
		data() {
			return {
				userBuy: false,
				dialogReplyViable: false,
				selAddressIndex: 0,
				curAddress: {},
				sucPop: false,
				tipPop: false,
				errorDesc: '',
				address: [],
				agree: true,
				count: 1,
			}
		},
		mounted() {
			this.userAddress()
		},
		methods: {
			handleClose() {
				this.$emit('close')
			},
			prevImage() {
				const prevIndex = (this.selAddressIndex - 1 + this.address.length) % this.address.length;
				this.selAddressIndex = prevIndex;
				this.scrollToImage();
			},
			nextImage() {
				const nextIndex = (this.selAddressIndex + 1) % this.address.length;
				this.selAddressIndex = nextIndex;
				this.scrollToImage();
			},
			scrollToImage() {
				const container = this.$refs.thumbnailContainer;
				const rootFontSize = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
				const thumbnailWidth = 2.88 * rootFontSize; // 每个缩略图的宽度，包括间隔
				const maxVisibleThumbnails = 3; // 显示的最大缩略图数量
				// 计算当前选中缩略图的偏移量
				const thumbnailOffset = this.selAddressIndex * thumbnailWidth;
				// 计算需要滚动的距离，保持最多显示3个缩略图
				if (thumbnailOffset >= container.scrollLeft + maxVisibleThumbnails * thumbnailWidth) {
					// 向右滚动
					container.scrollLeft = thumbnailOffset - maxVisibleThumbnails * thumbnailWidth + thumbnailWidth;
				} else if (thumbnailOffset < container.scrollLeft) {
					// 向左滚动
					container.scrollLeft = thumbnailOffset;
				}
			},
			reduceNum() {
				if (this.count > 1) {
					this.count--
				} else {
					this.$message.warning('最少兑换数量为1！')
				}
			},
			addNum() {
				if (this.count < this.goods.stock) {
					this.count++
				} else {
					this.$message.warning('库存不足！')
				}
			},
			errorChange() {
				this.tipPop = false;
				if (this.errorDesc == '积分不足') {
					this.$emit("exchangeError")
				}
			},
			userAddress() {
				this.$api.post('/UserD/user_address', {}).then(res => {
					if (res.code == 1) {
						this.address = res.data
						if (this.address.length) {
							this.selAddressIndex = 0
						}
					}
				}).catch(err => {
					console.log(err);
				})
			},
			delAddress(item) {
				this.$confirm('确认删除当前地址吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.post('/UserD/user_address_del', {
						id: item.id
					}).then(res => {
						if (res.code == 1) {
							this.userAddress()
						}
					}).catch(err => {
						console.log(err);
					})
				}).catch(err => {
					console.log(err);
				});
			},
			exchangeGoods() {
				if (this.goods.cat_type == 1) {
					if (!this.address.length) return this.$message.warning('请添加收货地址！')
					if (!this.agree) return this.$message.warning('请阅读并同意《用户购买须知协议》！')
					this.$api.post('/OrderIntegral/integral_order_add', {
						count: this.count,
						goods_id: this.goods.id,
						address_id: this.address[this.selAddressIndex].id,
					}).then(res => {
						if (res.code == 1) {
							this.sucPop = true
						} else {
							this.errorDesc = res.msg
							this.tipPop = true
						}
					}).catch(err => {
						console.log(err);
					})
				} else {
					this.$api.post('/OrderIntegral/voucher_add', {
						count: this.count,
						goods_id: this.goods.id,
					}).then(res => {
						if (res.code == 1) {
							this.sucPop = true
						} else {
							this.errorDesc = res.msg
							this.tipPop = true
						}
					}).catch(err => {
						console.log(err);
					})
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.integral-goods-details-container {
		width: 100%;
		background: #FFFFFF;
		padding: .24rem .4rem;
		display: flex;
		flex-direction: column;
	}

	.backBox {
		display: flex;
		align-items: center;
		font-weight: 400;
		font-size: .14rem;
		color: #000000;
		cursor: pointer;

		.backIcon {
			width: .06rem;
			height: .1rem;
			margin-right: .06rem;
		}
	}

	.userInfoItem {
		margin-top: .24rem;
		display: flex;
		flex-direction: column;
		background: #FFFFFF;
		border-radius: .12rem;

		.itemTitle {
			display: flex;
			align-items: center;
			justify-content: space-between;
			font-weight: 600;
			font-size: .16rem;
			color: #333333;

			.addressMenu {
				display: flex;
				align-items: center;

				.addAddress {
					margin-left: .16rem;
					font-weight: 400;
					font-size: .12rem;
					color: #333333;
					cursor: pointer;
				}
			}
		}

		.itemContent {
			display: flex;
			flex-direction: column;
			position: relative;

			.prev-btn,
			.next-btn {
				position: absolute;
				width: .12rem;
				height: .28rem;
				padding: 0 0;

				img {
					width: .12rem;
					height: .28rem;
				}
			}

			.prev-btn {
				top: calc(50% - .07rem);
				left: 0;
			}

			.next-btn {
				top: calc(50% - .07rem);
				right: 0;
			}

			.addressList {
				margin-top: .16rem;
				width: 100%;
				display: flex;
				white-space: nowrap;
				border-left: .14rem solid #FFFFFF;
				border-right: .14rem solid #FFFFFF;
				overflow-x: auto;

				.active {
					border: .01rem solid #E29358;
				}

				.normal {
					border: .01rem solid #CCCCCC;
				}

				.addressItem {
					flex-shrink: 0;
					margin-right: .16rem;
					width: 2.72rem;
					height: .95rem;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					padding: .16rem .16rem;
					border-radius: .08rem;
					cursor: pointer;
					position: relative;

					.editMenu {
						position: absolute;
						bottom: .2rem;
						right: .12rem;
						display: flex;
						align-items: center;

						.editIcon {
							margin-left: .08rem;
							width: .12rem;
							height: .12rem;
						}
					}

					.province {
						font-weight: 400;
						font-size: .12rem;
						color: #1C1C1C;
					}

					.address {
						font-weight: 500;
						font-size: .14rem;
						color: #1C1C1C;
					}

					.namePhone {
						font-weight: 400;
						font-size: .12rem;
						color: #1C1C1C;
					}
				}
			}

			.addressList::-webkit-scrollbar {
				width: 0;
				height: 0;
			}

			/* Firefox */
			.addressList {
				scrollbar-width: none;
				/* Firefox 隐藏滚动条 */
			}

			/* IE / Edge 老版本 */
			.addressList {
				-ms-overflow-style: none;
				/* IE11, Edge */
			}
		}
	}




	.integral-goods-details {
		margin-top: .24rem;
		display: flex;
		align-items: center;

		.integral-goods {
			margin-left: .32rem;
			display: flex;
			flex-direction: column;

			.title {
				font-weight: 700;
				font-size: .2rem;
				color: #000000;
			}

			.price {
				font-weight: 700;
				font-size: .16rem;
				color: #FF0000;
			}

			.specs,
			.inventory,
			.buyCount {
				font-weight: 400;
				font-size: .16rem;
				color: #666666;
			}

			.infoTitle {
				display: inline-block;
				width: .8rem;
			}
		}
	}

	.exchangNum {
		display: flex;
		flex-direction: column;
		font-weight: 400;
		font-size: .12rem;
		color: #666666;

		.numBox {
			margin-top: .16rem;
			display: flex;
			align-items: center;

			img {
				width: .28rem;
				height: .28rem;
				cursor: pointer;
			}

			.num {
				width: .32rem;
				height: .28rem;
				font-weight: 500;
				font-size: .14rem;
				color: #000000;
				line-height: .28rem;
				text-align: center;
			}
		}
	}

	.agreementBox {
		margin: .24rem auto 0;
		display: flex;
		align-items: center;
		font-size: .12rem;

		.checkIcon {
			margin-right: .06rem;
			width: .14rem;
			height: .14rem;
			cursor: pointer;
		}

		.userAgreement {
			color: #E29358;
			cursor: pointer;
		}
	}

	.exchange {
		margin: .24rem auto 0;
		width: 2.6rem;
		height: .52rem;
		background: #E29358;
		border-radius: .06rem;
		font-weight: 500;
		font-size: .15rem;
		color: #252525;
		line-height: .52rem;
		text-align: center;
		cursor: pointer;
	}
</style>
<style scoped>
	.image-gallery {
		display: flex;
		align-items: center;
	}

	.main-image {
		display: flex;
		align-items: center;
		position: relative;
	}

	.main-image img {
		width: 1.35rem;
		height: 1.35rem;
		object-fit: cover;
		border-radius: .1rem;
	}

	.main-imageT img {
		width: 2.08rem;
		height: 2.08rem;
		object-fit: cover;
		border-radius: .1rem;
	}
</style>